import { createApp } from "vue";
import hash from "../../hash";
import { ModalHelper } from "../../B2bTools";
//
import flatpickrVue from 'vue-flatpickr-component';
import { may, toDate, flatPickrConfig, traduit } from "../composant/b2bLangue";
import html from "./seasonList.html";
import htmlSeasonEdit from "./season@edit.html";
import htmlSeasonOpen from "./seasonList@open.html";

import Fuse from 'fuse.js'
const fuseOptions = {
    threshold: 0.0,
    keys: [
        'k',
        'v',
        'market'
    ]
}

/* const titles = [
    'Code (M3)',
    'Description',
    'Orders confirmation date (COL)',
    'Market (PLM)',
]
 */ 

const js = ({
    url: function (echangeur) {
        echangeur.addAction('b2b.toc.list', { env: echangeur.hash.u }, '', 'toc');
        echangeur.addAction('b2b.codification.select', { classe: "market" }, '', 'market');
        echangeur.addAction('b2b.codification.select', { classe: "SEASON" }, '', 'season');
        echangeur.addAction('b2b.env.getDefault', {env: echangeur.hash.u}, '', 'default'); 
    },
    onLoad: function (echangeur) {
        let THIS = this;

        const app = createApp({
            data: () => ({
                datas: echangeur.toc.rows,
                //titles: titles,
                isEditeur: may("MAJSEASON"),
                // fuse: null,
                // search: null,
                // searchKey: null,
                fuse: null,
                searchKey: '',
                markets: echangeur.default.rows,
                currentMarket: echangeur.default.tocK,
                flatPickrConfig: flatPickrConfig,
            }),
            methods: {
                goToSeason(toc) {
                    hash.lance("season", { _id: toc._id });
                },

                importProduct() {
                    hash.lance("importproduct");
                },

                toDate: function (date) {
                    return toDate(date);
                },
                lanceRecherche(val) {
                    const index = 'k'
                    const data = this.datas
                    if (data && val) {
                        const searchIndex = this.fuse.search(val).map(u => u.item[index]);
                        data.map(u => u.inSearch = (searchIndex.includes(u[index])))
                    }
                },
                isActive(k) {
                    return (this.markets && this.markets.indexOf(k) >= 0)
                },
                // lanceRecherche(val) {
                //     this.search = this.fuse.search(val);
                //     let indexSearch = this.search.map(e => {
                //         return e.item._id;
                //     });
                //     let countUserAff = 0;
                //     this.datas.map(u => {
                //         u.inSearch = (indexSearch.indexOf(u._id) > -1);
                //         if (u.show) countUserAff += 1;

                //     })
                //     if (this.allSelected && indexSearch.length != countUserAff) this.allSelected = false;
                // },

                seasonEdit() {
                    if (!this.isEditeur) return;
                    const thisParent = this;

                    const modaleApp = createApp({
                        data: function () {
                            return {
                                saisie: {
                                    ...thisParent.datas,
                                    /* Checkbox */
                                    onstock: false,
                                    withdelivdates: true
                                },
                                univers: echangeur.hash.u,

                                error: {},
                                options: {
                                    market: echangeur.market.rows,
                                    season: echangeur.season.rows,
                                },
                                flatPickrConfig: flatPickrConfig,
                            }
                        },
                        components: {
                            'flatpickr-vue': flatpickrVue
                        },
                        methods: {
                            close: function () {
                                ModalHelper.hide();
                            },
                            async save() {
                                const thisVue = this;
                                console.log(this.saisie.v);
                                if (String(this.saisie.codem3).replaceAll(/\s/g, '').toUpperCase() !== "UNDEFINED" && String(this.saisie.k).replaceAll(/\s/g, '').toUpperCase() !== "UNDEFINED" && this.saisie.v !== undefined && this.saisie.market !== undefined) {
                                    

                                    const form = {
                                        "k": String(this.saisie.k).replaceAll(/\s/g, '').toUpperCase(),
                                        "v": this.saisie.v,
                                        "codem3": String(this.saisie.codem3).replaceAll(/\s/g, '').toUpperCase(),
                                        "dateMinimum": this.saisie.dateMinimum,
                                        "market": this.saisie.market,
                                        "season": this.saisie.season,
                                        "env": this.univers
                                    }

                                    Object.values(form).map((x, i) => {
                                        thisVue.error[Object.keys(form)[i]] = (!x)
                                    })

                                    // if (Object.values(form).every(x => x)) {
                                        const retour = await THIS.rest("b2b.toc.create", {}, form);
                                        this.close();
                                        hash.lance("season", { _id: retour.doc._id });
                                        // const result = await THIS.rest("b2b.toc.saveHeader", { "_id": _id }, form);
                                        // thisParent.datas = result.doc;
                                        // this.close()
                                    // }
                                }
                            },
                        },
                        mounted() {
                            ModalHelper.show(async function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlSeasonEdit).container);
                },

                // seasonEdit() {
                //     if (!this.isEditeur) return;
                //     const modaleApp = createApp({
                //         components: {
                //             'flatpickr-vue': flatpickrVue
                //         },
                //         data: function () {
                //             return {
                //                 datas: {
                //                     "k": "",
                //                     "v": "",
                //                     "dateMinimum": "",
                //                     "market": ""
                //                 },
                //                 options: {
                //                     market: echangeur.market.rows,
                //                 },
                //                 error: {
                //                     k: "", v: "", market: ""
                //                 },
                //                 flatPickrConfig: flatPickrConfig,

                //             }
                //         },
                //         methods: {
                //             close: function () {
                //                 ModalHelper.hide();
                //             },
                //             reset() {
                //                 this.error.k = false
                //                 this.error.v = false
                //                 this.error.market = false
                //             },

                //             async save() {
                //                 const thisVue = this;
                //                 this.reset()

                //                 if (this.datas.k) {
                //                     this.datas.k = ("" + this.datas.k).replaceAll(/\s/g, '').toUpperCase()
                //                 }

                //                 function nbe() {
                //                     let nb = 0;
                //                     for (let key in thisVue.error) if (thisVue.error[key]) nb++;
                //                     return nb;
                //                 }

                //                 const form = {
                //                     "k": this.datas.k,
                //                     "v": this.datas.v,
                //                     "dateMinimum": this.datas.dateMinimum,
                //                     "market": this.datas.market
                //                 }

                //                 if (!form.k) { this.error.k = "Code is required" }
                //                 else {
                //                     const exists = await THIS.rest("b2b.toc.byPk", { k: form.k })
                //                     if (exists) this.error.k = "Already exist"
                //                 }

                //                 if (!form.v) this.error.v = "Description is required"
                //                 if (!form.market) this.error.market = "Market is required"

                //                 if (!nbe()) {
                //                     const retour = await THIS.rest("b2b.toc.create", {}, form);
                //                     this.close();
                //                     hash.lance("season", { _id: retour.doc._id });
                //                 }
                //             },
                //         },
                //         mounted() {
                //             ModalHelper.show(function () {
                //                 modaleApp.unmount();
                //             });
                //         }
                //     })
                //     modaleApp.mount(ModalHelper.html(htmlSeasonEdit).container);
                // },

                // async seasonOpen() {
                //     const vueParent = this;
                //     const form = await THIS.rest("b2b.env.getDefault", {});
                //     const modaleApp = createApp({
                //         data: function () {
                //             return {
                //                 selectToc: echangeur.toc.rows,
                //                 currentMarket: form.tocK,
                //                 tocK: form.tocK,
                //                 confirmQuestion: false,
                //                 confirmCheckbox: false
                //             }
                //         },
                //         methods: {
                //             close() {
                //                 ModalHelper.hide();
                //             },
                //             async save() {
                //                 if (!this.confirmQuestion) {
                //                     return this.confirmQuestion = true
                //                 }
                //                 if (this.confirmCheckbox) {
                //                     const result = await THIS.rest("b2b.env.setDefault", { tocK: this.tocK });
                //                     if (result.ok) {
                //                         this.close();
                //                         vueParent.currentMarket = this.tocK;
                //                     }
                //                 }
                //             }
                //         },
                //         mounted() {
                //             ModalHelper.show(function () {
                //                 modaleApp.unmount();
                //             });
                //         }
                //     })
                //     modaleApp.mount(ModalHelper.html(htmlSeasonOpen).container);
                // },

                t(value) {
                    return traduit(value, 'global')
                }

            },
            watch: {
                "searchKey"(val) {
                    this.lanceRecherche(val);
                }
            },
            mounted() {
                this.fuse = new Fuse(this.datas, fuseOptions);
            }
        });

        app.mount(THIS.c$('._vueChargement')[0]);

    },

});

export default {
    seasonList: { js: js, html: html }
};